import { push } from 'react-router-redux';
import update from 'immutability-helper';
 import Notifications from 'react-notification-system-redux';

import { authLoginUserFailure, authLoginMessage } from '../../../actions/auth';
import { checkHttpStatus, parseJSON } from '../../../utils';
import {
   fetchRegisterUser,
   fetchRegisterAgency,
 } from '../../../core/api';

// ------------------------------------
// Constants
// ------------------------------------
export const REGISTER_FETCH_FAILURE = 'REGISTER_FETCH_FAILURE';
export const REGISTER_FETCH_REQUEST = 'REGISTER_FETCH_REQUEST';
export const REGISTER_FETCH_SUCCESS = 'REGISTER_FETCH_SUCCESS';
// ------------------------------------
// Actions
// ------------------------------------
export function registeringAgency() {
  return {
    type: REGISTER_FETCH_REQUEST,
    payload: null,
  };
}
export function registerAgencySuccess(json) {
  return {
    type: REGISTER_FETCH_SUCCESS,
    payload: json,
  };
}
export function registerAgencyFailure(json) {
  return {
    type: REGISTER_FETCH_FAILURE,
    payload: json,
  };
}
export function registerAgency(payload) {
  console.log('registerAgency -> ', payload);
  return (dispatch) => {
    dispatch(registeringAgency());
    return fetchRegisterAgency(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(authLoginMessage('Please check your email for login credentials.'));
        dispatch(push('/agency'));
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Awesome, Welcome to Catch!',
          message: 'Check your email for the next step.',
          autoDismiss: 20,
        };
        dispatch(Notifications.success(notificationOpts));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
              dispatch(registerAgencyFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
              // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            return dispatch(registerAgencyFailure({ message: 'Unable to register your agency.' }));
          }
        }
        console.log('An error occurred while sending your data!', error);
        return dispatch(registerAgencyFailure({ message: 'Unable to register your agency.' }));
      });
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [REGISTER_FETCH_SUCCESS]: (state, action) => update(
      state,
      { status: { $set: 'Congrats. You are on your way to using Catch.' } },
    ),
  [REGISTER_FETCH_FAILURE]: (state, action) => {
    return update(
      state,
      { status:
      {
        $set: action.payload.message,
      },
      },
    );
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  status: 'Let\'s get started.',
};

export default function registerReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// src/routes/agency/modules/register.js